<template>
    <div class="container mt-5">
    <router-link class="btn-back" to="/solutions/marketplace"><i class="fas fa-long-arrow-alt-left"></i> Retourner à la page précédente</router-link>
    <div class="titleProduct">Viticulteurs.market</div>
    <div class="subTitle">Le fournisseur des professionnels de la Vigne et du Vin</div>
    
    <div class="row">
        <div class="col-md-6">
            Maitriser les approvisionnements, assurer le meilleur service auprès des professionnels du secteur, se positionner comme un acteur important de la filière et un partenaire des industries connexes. Viticulteurs.market est une place de marché et une application mobile gratuite (Apple Store/Google Play) qui permettent aux viticulteurs de réaliser de bonnes affaires, d’avoir accès à un offre produits/services spécifiques, et de bénéficier des meilleurs prix du marché en leur proposant des articles/biens vendus par les professionnels du secteur, disponible en dans les magasins partenaires ou à la livraison (en fonction du type de biens et de la politique commerciale du vendeur)
        </div>
        <div class="col-md-6">
            <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/5_vXQFQ1zPU" allowfullscreen></iframe>
            </div>
        </div>
    </div>
    <div class="mt-4 mb-4">
        Pour cela, la confiance est au coeur des échanges. Des conseillers-vendeurs sont disponibles en magasins ou en ligne via la messagerie instantanée pour aider dans les viticulteurs dans leurs choix. La proximité et le local sont de mise car les viticulteurs recherchent des produits, des bonnes affaires dans leur région, leur secteur géographique, ainsi que du matériel et des produits autour d’eux.
        Les fonctionnalités de la place de marché : photo, vidéo, paiement mobile, partage sur Facebook, messagerie instantanée, boutiques personnalisées pour les partenaires vendeurs, gestion des commandes et notifications à chaque étape du processus de vente/achat, un magazine en ligne, tout ceci au travers d’un site web et d’une application simple et gratuite .
    </div>

    <div class="title">Clients et partenaires</div>
    <div class="row clients-logo text-center">
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/ceresia.png" alt=""></div>
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/acolyance.png" alt=""></div>
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/prestalyance.png" alt=""></div>
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/gallorema.png" alt=""></div>
    </div>
    
    <div class="row mt-5 mb-5 text-center">
        <a class="btn btn-secondary-outline ml-auto" href="" target="blank">Aller sur le Viticulteurs.market</a>
        <router-link class="btn btn-primary mr-auto" to="/contact"><i class="fas fa-long-arrow-alt-left"></i> Devenir partenaire</router-link>
    </div>

    <Contact/>

  </div>
</template>

<script >
import Contact from '@/components/Contact'

export default {
    name: 'AVM',
    components:{
        Contact
    },
    props:{}
}
</script>

<style lang="scss" scoped>

      .titleProduct{
        text-align: left;
        font-weight: 600;
        font-size: 55px;
        color: var(--mainBlue);
        padding-top: 50px;
    }

    .btn {
        padding: 15px;
        font-weight: 600;
        margin: 20px;
        min-width: 300px;
    }


</style>